import React from 'react'
import { Box } from 'rebass'
import { withTheme } from 'styled-components'
import typography from '../../utils/typography'
import ContentOmniSearchResults from '../../components/ContentOmniSearchResults'
import { connect } from 'react-redux'
import { clearSearchTerm } from '../../state/search/actions'
import Layout from '../../components/Layout'
import searchFn from '../../state/search/lib/search'

const Wrapper = withTheme(({ theme, children }) => (
  <Box
    bg={theme.colors.blue_light}
    pb={[typography.rhythm(2), typography.rhythm(3)]}
  >
    {children}
  </Box>
))

class SearchResults extends React.PureComponent {
  constructor(...args) {
    super(...args)
    this.state = {
      results: [],
      phrase: this.props.searchTerm
    }

    this.getResults = this.getResults.bind(this)
  }

  async getResults(phrase) {
    const results = await searchFn(phrase, 25)
    this.setState({ results })
  }

  componentDidMount() {
    this.getResults(this.props.searchTerm)
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.currentSearchTerm) {
      this.getResults(nextProps.currentSearchTerm)
      this.setState({
        phrase: nextProps.currentSearchTerm
      })
    }
  }

  componentWillUnmount() {
    this.props.clearSearchTerm()
  }

  render() {
    return (
      <Layout location={this.props.location}>
        <Wrapper>
          <ContentOmniSearchResults
            results={this.state.results}
            searchTerm={this.state.phrase}
          />
        </Wrapper>
      </Layout>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearSearchTerm: () => dispatch(clearSearchTerm())
  }
}

export default connect(
  (state) => ({ ...state.search }),
  mapDispatchToProps
)(SearchResults)
